/** sessionStorage, never the URL: Sentry replay masks DOM text but not URLs, and this is PHI. */
const TOPIC_KEY = "progressCareTeamMessageTopic";

export const stashCareTeamMessageTopic = (topic: string) => {
  try {
    window.sessionStorage.setItem(TOPIC_KEY, topic);
  } catch {
    /* Private browsing or a full store: the composer simply opens empty. */
  }
};

export const takeCareTeamMessageTopic = () => {
  try {
    const topic = window.sessionStorage.getItem(TOPIC_KEY);

    window.sessionStorage.removeItem(TOPIC_KEY);

    return topic;
  } catch {
    return null;
  }
};

/** Cleared on logout: an unread topic would prefill the next patient's composer on that tab. */
export const clearCareTeamMessageTopic = () => {
  try {
    window.sessionStorage.removeItem(TOPIC_KEY);
  } catch {
    /* Nothing was stored, so there is nothing to leak. */
  }
};
